<template>
    <div class="app-bank-account">
      <b-form-group class="account-holder-group">
        <b-row>
          <b-col class="label-col" md="" sm="12">
            <label for="owner" class="mandatory d-inline-block"><slot name="lblOwner">Kontoinhaber</slot></label>
          </b-col>
          <b-col md="" sm="12">
            <b-form-input
              name="owner"
              id="owner"
              type="text"
              class="form-col"
              v-model="inputOwner"
              required
              @input="$v.inputOwner.$touch"
              :state="isValid('inputOwner')">
            </b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="iban-group">
        <b-row>
          <b-col class="label-col" md="" sm="12">
            <label for="iban" class="mandatory d-inline-block"><slot name="lblIban">IBAN</slot></label>
          </b-col>
          <b-col md="" sm="12">
            <b-form-input
              name="iban"
              id="iban"
              type="text"
              class="form-col"
              v-model="inputIban"
              required
              @input="$v.inputIban.$touch"
              :state="isValid('inputIban')">
            </b-form-input>
            <b-form-invalid-feedback id="iban-live-feedback">
              <slot v-if="$v.inputIban.ibanValidator === false" name="txtIbanLiveFeedback">
                Bitte überprüfen Sie ihre IBAN
              </slot>
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="payment-confirmation-group">
        <b-row>
          <b-col cols="12">
            <b-form-checkbox
              v-model="inputPaymentConfirmation"
              required
              class="payment-confirmation-checkbox manda"
              @input="$v.inputPaymentConfirmation.$touch"
              :state="isValid('inputPaymentConfirmation')"
              id="sepamandate"
            >
              <div class="lblPaymentConfirmation mandatory">
                <slot v-if="!isPUC" name="lblPaymentConfirmation">Ich ermächtige/Wir ermächtigen die Vodafone GmbH (Gläubiger-ID: DE26ZZZ00000006194), Zahlungen von meinem/unserem Konto mittels Lastschrift einzuziehen. Zugleich weise ich mein/weisen wir unser Kreditinstitut an, die von der Vodafone GmbH auf mein/unser Konto gezogenen Lastschriften einzulösen. Hinweis: Ich kann/Wir können innerhalb von acht Wochen, beginnend mit dem Belastungsdatum, die Erstattung des belasteten Betrages verlangen. Es gelten dabei die mit meinem/unserem Kreditinstitut vereinbarten Bedingungen.</slot>
                <slot v-if="isPUC" name="lblPaymentConfirmation">Hiermit erteile ich das <a>SEPA-Lastschriftmandat<sup>*</sup></a></slot>
              </div>
              <b-form-invalid-feedback>
                <slot name="txtConfirmationRequired">Dies ist ein Pflichtfeld.</slot>
              </b-form-invalid-feedback>
            </b-form-checkbox>
            <div v-if="isPUC&&isValid('inputPaymentConfirmation')" class="txtPaymentConfirmationDescription">
              <div v-for="term in brandConsents.consents" :key="term.text">
                <p v-html="term.text"></p>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-form-group>
    </div>
</template>

<script>
import { wrapQuery } from '../../../../helper/wrapGQLQuery'
import gql from 'graphql-tag'
import { validationMixin } from 'vuelidate'
import isValid from '../../../../mixins/validators/isValid'
import { helpers, required, sameAs } from 'vuelidate/lib/validators'
import syncProperty from '../../../../mixins/syncProperty'
const ibanValidator = helpers.regex('ibanValidator', /[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{7}([a-zA-Z0-9]?){0,16}/)

export default {
  name: 'PaymentBankAccount',
  data () {
    return {
      brandConsents: {
        consents: [{
          text: ''
        }
        ]
      },
      brand: ''
    }
  },
  watch: {
    '$v.$invalid': function (newValue) {
      this.$emit('update:invalid', newValue)
    }
  },
  mixins: [
    validationMixin,
    isValid,
    syncProperty('iban', 'inputIban'),
    syncProperty('owner', 'inputOwner'),
    syncProperty('paymentConfirmation', 'inputPaymentConfirmation')
  ],
  props: {
    isPUC: {
      type: Boolean
    },
    filterKeys: {
      type: String,
      default: 'privilege_terms'
    }
  },
  validations () {
    return {
      inputOwner: {
        required
      },
      inputIban: {
        required,
        ibanValidator
      },
      inputPaymentConfirmation: {
        sameAs: sameAs(() => true)
      }
    }
  },
  apollo: {
    brandConsents: function () {
      const query = wrapQuery(gql`query prevTerms ($brand: String!, $filterKeys: [String!]) {
        brandConsents(brand:$brand, filterKeys: $filterKeys) {
          consents {
            text
          }
        }
      }`, this, 'brandConsents', {
        brand: this.$store.getters.brand,
        filterKeys: this.filterKeys
      })
      return query
    }
  }
}
</script>
